/// <reference path = "~/Scripts/jQuery/jquery-1.7.1.min.js" />

$(document).ready(function () {
    initExpandCollapseUpdated();    
});

function initExpandCollapseUpdated() {
    $("body").on("click", ".ag.update", function (e) {
        var $clicked = $(this);
        var $added = $clicked.parents(".gi:first");

        $added.addClass("hidden");

        //Throw event for pages to handle groups
        $.event.trigger({
            type: "glGroupAdded",
            gID: $added.attr("gid"),
            gLvl: $added.attr("lvl"),
            gAdded: $added,
            source: $clicked.parents(".groupListContainer").attr("source")
        });
    });    

    $("body").on("click", ".al", function (e) {
        var $clicked = $(this);
        var $added = $clicked.parent();

        $added.addClass("hidden");  //Have to figure out how to hide/unhide these correctly

        //Throw event for pages to handle logins
        $.event.trigger({
            type: "glLoginAdded",
            lID: $added.attr("lid"),            
            lAdded: $added,
            source: $clicked.parents(".groupListContainer").attr("source")
        });
    });

    //Click on to expand roles
    $("body").on("click", ".sp", function () {
        var $clicked = $(this);
        var $added = $clicked.parents(".gi:first");
        var $profiles = $clicked.next();
        var marginLeft = parseInt($clicked.children().first().css("margin-left")) + 24;

        $clicked.prop('disabled', true);

        if (!$profiles.hasClass("pc")) {
            AdminService.LoadGroupListProfiles($clicked.attr("lvl"), marginLeft,
                function (result) {
                    $clicked.after(result);
                },
                function (error) { showErrorMessage(error.get_message()); }
            );
        }
        else {
            if ($profiles.hasClass("hidden"))
                $profiles.removeClass("hidden");
            else
                $profiles.addClass("hidden");
        }

        setTimeout(function () {
            $clicked.prop('disabled', false);
        }, 1000);
    });

    $("body").on("click", ".ap", function (e) {
        var $clicked = $(this);
        var $added = $clicked.parent();
        var $groupItem = $added.parent().prev();
        var $msgDisplay = $(".msgDisplay");
        var $newWorkAidSelectedGroups = $msgDisplay.find(".newWorkAidSelectedGroups");
        var $msgSelectedLogins = $msgDisplay.find(".msgSelectedLogins");

        //$added.addClass("hidden");

        //Throw event for pages to handle profiles
        if ($clicked.prop("checked")) {
            $.event.trigger({
                type: "glProfileAdded",
                pID: $added.attr("pid"),
                pLvl: $added.attr("plvl"),
                gID: $groupItem.attr("gid"),
                gLvl: $groupItem.attr("lvl"),
                pAdded: $added,
                pGroupItem: $groupItem,
                source: $clicked.parents(".groupListContainer").attr("source")
            });
        }
        else {
            // SECTION IS NEEDED FOR 17.1 RELEASE -- WILL BE REMOVED AFTER RELEASE
            //for (var i = 0; i < $msgSelectedLogins.length; i++) {
            //    if ($msgSelectedLogins[i].getAttribute("pid") == $added.attr("pid") && $msgSelectedLogins[i].getAttribute("plvl") == $added.attr("plvl"))
            //        $msgSelectedLogins[i].remove();
            //}

            // SECTION WILL BE UTILIZED POST 17.1 RELEASE
            $.event.trigger({
                type: "glProfileRemoved",
                pID: $added.attr("pid"),
                pLvl: $added.attr("plvl"),
                gID: $groupItem.attr("gid"),
                gLvl: $groupItem.attr("lvl"),
                pAdded: $added,
                pGroupItem: $groupItem,
                source: $clicked.parents(".groupListContainer").attr("source")
            });
        }
    });

    $("body").on("click", ".unpressed, .pressed", function (e) {
        $(this).toggleClass("unpressed pressed");
    });
    
    $("body").on("click", ".expandCollapseAll.update", function (e) {
        $(this).toggleClass("collapseAll expandAll");
        var expanded = $(this).hasClass("expandAll");
        $(".gi").each(function (e) {
            if ($(this).parents(".cgi").length > 0) {
                $(this).parent(".cgi").toggleClass("hdn");
                $(this).children(".eci").toggleClass("ex cls hdn");
            }
            else
                $(this).children(".eci").toggleClass("ex cls");
        });
    });

    $("body").on("click", ".eci.update", function (e) {
        if ($(this).hasClass("expandCollapseAll")) return;

        e.stopPropagation();
        $(this).toggleClass("cls ex");
        $(this).parent().nextAll().children().children(".eci").toggleClass("hdn");
        $(this).parent().nextAll(".cgi").toggleClass("hdn");        
    });

    $("body").on("click", ".ecl", function (e) {
        var $clicked = $(this);
        var $parent = ($clicked.parent().parent().hasClass("gi") ? $clicked.parent().parent() : $clicked.parent().parent().parent());
        var $lc = $parent.next();
        
        $lc.toggleClass("hdn");
    });

    $("body").on("focus", ".txtSearch", function () {        
        var $groupListContainer = $(".groupListContainer[source='" + $(this).parent().attr("source") + "']")

        //Only setup the searchable if it hasn't been done to this control
        if (!$groupListContainer.hasClass("searchableReady"))
            SetupSearchable($groupListContainer);
    });

    $("body").on("keyup", ".txtSearch", function () {
        var $txtSearch = $(this);
        var $groupListContainer = $(".groupListContainer[source='" + $txtSearch.parent().attr("source") + "']")
        var searchTerm = $txtSearch.hasClass("watermark") ? "" : $txtSearch.val();

        clearTimeout($txtSearch.data("waitForStop"));
        $txtSearch.data("waitForStop", setTimeout(function () { SearchGroupList($groupListContainer, searchTerm) }, 1000));
    });
}

function SetupSearchable($groupListContainer) {
    //Add class so we don't try to resetup the control for search
    $groupListContainer.addClass("searchableReady");

    //Go through each gi and add the class and attr needed for search
    $groupListContainer.find(".gi").each(function () {
        var $gi = $(this);

        $gi.addClass("sT"); //searchableText
        $gi.attr("sOn", $gi.text().toUpperCase()); //searchOn
    });

    //Go through each cgi and add class so we know they are searhable containers
    $groupListContainer.find(".cgi").addClass("sC"); //searchableContainer
}

function SearchGroupList($groupListContainer, searchTerm) {
    if (searchTerm.length == 0) {
        $groupListContainer.find(".hidden").removeClass("hidden");
        $groupListContainer.find(".sC, .eci").addClass("hdn");
        $groupListContainer.find(".eci").removeClass("ex").addClass("cls");
        $groupListContainer.find(".eci:first").removeClass("hdn");
        return;
    }

    $groupListContainer.find(".sT, .sC, .eci").addClass("hidden").end().find(".eci").removeClass("ex").addClass("cls hdn");

    $groupListContainer.find(".gi[sOn*='" + searchTerm.toUpperCase() + "']").removeClass("hidden") //matched searchTerm
        .find(".eci").removeClass("hidden hdn").end() //trigger("click") //toggle expand
        .parents(".sC").removeClass("hidden hdn") //parents of searchTerm
        .prevAll(".sT").removeClass("hidden hdn") //Text of parent
        .find(".eci").removeClass("hidden hdn").toggleClass("cls ex") //trigger("click") //toggle expand
        .end().end().end() //back to searchTerm
        .siblings(".sC").removeClass("hidden") //siblings of searchTerm (immediate children)
        .find(".hidden").removeClass("hidden") //children of all siblings of searchTerm (immediate children)        
}

//Pages that use this control will need to call 'glAddRemovedGroup' function so that we can handle that here
//The call should pass the gID and gLvl
function glAddGroups() {
    var $groupListContainer = $(".groupListContainer")

    $groupListContainer.find(".gi").each(function () {
        var $gi = $(this);

        $gi.removeClass("hidden");
    });
}

function glRemoveGroups() {
    var $groupListContainer = $(".groupListContainer")

    $groupListContainer.find(".gi").each(function () {
        var $gi = $(this);
        $gi.addClass("hidden");
    });
}

//Pages that use this control will need to call 'glAddRemovedGroup' function so that we can handle that here
//The call should pass the gID and gLvl
function glAddRemovedGroup(gid, glvl) {
    $(".gi[gid='" + gid + "'][lvl='" + glvl + "']").removeClass("hidden");
}

//Pages that use this control will need to call 'glRemoveGroup' function so that we can handle that here
//The call should pass the gID and gLvl
function glRemoveGroup(gid, glvl) {
    $(".gi[gid='" + gid + "'][lvl='" + glvl + "']").addClass("hidden");
}

//Pages that use this control will need to call 'glAddRemovedLogin' function so that we can handle that here
//The call should pass the lID
function glAddRemovedLogin(lid) {
    $(".li[lid='" + lid + "']").removeClass("hidden");
}

//Pages that use this control will need to call 'glAddRemovedProfile' function so that we can handle that here
//The call should pass the pID
function glAddRemovedProfile(pid, plvl) {
    $(".pi[pid='" + pid + "'][plvl='" + plvl + "']").removeClass("hidden");
}